import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// P8 new & returning — New-customers campaign.
export const campP8NrNew: FaireAdCampaignEntity = {
  token: "camp_p8_nr_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p8_new_returning",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 6000,
  startedRunningAt: "2023-10-24",
  segmentMetrics: {
    numCustomersAcquired: 129,
    salesDollars: 57977,
    totalAdsSpendDollars: 11625,
    cpaDollars: 90,
    bestEstimateSalesDollars: 57977,
    bestEstimateRoas: 4.99,
  },
  topCustomers: [
    {
      retailerName: "Cedarhouse Goods",
      storeType: "Home & gift",
      location: "Asheville, NC",
      totalOrders: 4,
      totalAmountDollars: 1840,
      lastOrderedAt: "2026-06-12",
    },
    {
      retailerName: "The Maple Row",
      storeType: "Boutique",
      location: "Madison, WI",
      totalOrders: 2,
      totalAmountDollars: 910,
      lastOrderedAt: "2026-05-29",
    },
    {
      retailerName: "Harbor & Pine",
      storeType: "Gift shop",
      location: "Portland, ME",
      totalOrders: 1,
      totalAmountDollars: 512,
      lastOrderedAt: "2026-04-22",
    },
  ],
  performancePeriodTokens: [
    "perf_p8_nr_new_202604",
    "perf_p8_nr_new_202605",
    "perf_p8_nr_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
